/** Shared utilities for traveller list components. */

import type { AdditionalTraveller, Relationship } from '@elara/domain/models/schemas/TravelerProfileSchema';

import { RelationshipSchema } from '@elara/domain/models/schemas/TravelerProfileSchema';

export const RELATIONSHIP_OPTIONS = RelationshipSchema.options.map((value) => ({
  value,
  label: value.charAt(0).toUpperCase() + value.slice(1),
}));

export function emptyTraveller(): AdditionalTraveller {
  return { firstName: '', lastName: '', dateOfBirth: '', relationship: '' as Relationship };
}

/** Relationships that mark a traveller as a child — used to gate the age input. */
export const CHILD_RELATIONSHIPS: ReadonlySet<Relationship> = new Set(['son', 'daughter', 'child']);

export function isChildRelationship(relationship: Relationship | '' | undefined): boolean {
  return !!relationship && CHILD_RELATIONSHIPS.has(relationship as Relationship);
}

/** True when every field is empty — the card can be silently discarded. */
export function isTravellerEmpty(t: AdditionalTraveller): boolean {
  return !t.firstName && !t.lastName && !t.relationship && !t.dateOfBirth && t.age == null;
}

/** True when the required fields are filled in. */
export function isTravellerValid(t: AdditionalTraveller): boolean {
  return !!t.firstName && !!t.lastName && !!t.relationship;
}
